import { Pipe, PipeTransform } from '@angular/core';
import { getDay } from 'date-fns/getDay';

@Pipe({
  name: 'weekday',
})
export class WeekdayPipe implements PipeTransform {
  transform(value: Date, format: 'long' | 'short' = 'short'): string {
    const weekday = getDay(value);

    switch (weekday) {
      case 0:
        return format === 'long' ? 'app.weekdays.sun.long' : 'app.weekdays.sun.short';
      case 1:
        return format === 'long' ? 'app.weekdays.mon.long' : 'app.weekdays.mon.short';
      case 2:
        return format === 'long' ? 'app.weekdays.tue.long' : 'app.weekdays.tue.short';
      case 3:
        return format === 'long' ? 'app.weekdays.wed.long' : 'app.weekdays.wed.short';
      case 4:
        return format === 'long' ? 'app.weekdays.thu.long' : 'app.weekdays.thu.short';
      case 5:
        return format === 'long' ? 'app.weekdays.fri.long' : 'app.weekdays.fri.short';
      case 6:
        return format === 'long' ? 'app.weekdays.sat.long' : 'app.weekdays.sat.short';
    }

    return '';
  }
}
